'use strict';

angular.module('app').directive('availabilityCalendar', function (gettextCatalog, $compile, utils, selectedLanguage) {
  var CELL_WIDTH = 30,
    today = moment().format('YYYY-MM-DD'),
    ROW_HEIGHT = 35;
  return {
    restrict: 'E',
    scope: true,
    bindToController: {
      dateFrom: '=',
      duration: '=',
      prices: '=',
      roomsAndGuests: '=',
      showCalendar: '=',
      roomSelected: '=',
      currency: '=',
      searchTriggered: '=',
      updateDate: '&',
    },
    templateUrl: (window.templatePath ? window.templatePath : '../') + 'templates/_availability-calendar.ssr.html',
    link: function (scope, elem) {
      var leftArrow = $('[data-scroll-left]'),
        rightArrow = $('[data-scroll-right]'),
        calendar = $('.dr-availability-calendar'),
        selectedRange = $('.selected-range'),
        selectedRangeText = $('.selected-range-text');

      scope.$watch(function () {
        return scope.calendar.availabilityCalendar;
      }, function (newVal) {
        if (!newVal || !newVal.length) {
          return true;
        }

        var compiled = _.template('<div class="dr-availability-calendar-row">' +
                        '<div class="room-title main-section-title"><%= title %></div>' +
                        '<div class="calendar-row">' +
                            '<% _.forEach(monthes, function(month) { %>' +
                            '<div class="calendar-row-date-text<% if (month) { %> first-elem<% } %>">' +
                                '<span><%= month %></span>' +
                            '</div>' +
                            '<% }); %>' +
                        '</div>' +
                    '</div>' +
                    '<div class="dr-availability-calendar-row">' +
                        '<div class="room-title"></div>' +
                        '<div class="calendar-row mbm">' +
                            '<% _.forEach(availabilityCalendar[0].details, function(d) { %>' +
                                '<div class="calendar-row-date-text"><%= moment(d.date).locale(selectedLanguage).format("D") %></div>' +
                            '<% }); %>' +
                        '</div>' +
                    '</div>' +
                    '<% _.forEach(availabilityCalendar, function(data) { %>' +
                    '<div class="dr-availability-calendar-row main-graph">' +
                        '<div class="room-title" smooth-scroll scroll-to="#room_<%= data.roomCategoryId %>" not-prevent="true">' +
                        '<% if (data.notAvailable) { %>' +
                            '<span class="title sold-out"><%= data.roomTitle %></span> <span class="room-price sold-out"><%= soldOutText %></div>' +
                        '<% } else { %>' +
                            '<span class="title"><%= data.roomTitle %></span> <span class="room-price" ng-bind="$root.setValue(<%= data.totalPrice %>, \'<%= currency %>\')"></div>' +
                        '<% } %>' +
                        '<div class="calendar-row">' +
                            '<% _.forEach(data.details, function(option) { %>' +
                                '<div class="calendar-row-date<% if (option.isAvailable && option.minPrice) { %> open<% } %><% if (option.selected) { %> active<% } %><% if (!option.isAvailable && !option.minPrice) { %> no-price<% } %>"></div>' +
                            '<% }); %>' +
                        '</div>' +
                    '</div><% }); %>');

        $('#availability-calendar').html($compile(compiled({
          'monthes': scope.calendar.monthes,
          'selectedLanguage': selectedLanguage,
          'title': gettextCatalog.getString('Room availability calendar'),
          'soldOutText': gettextCatalog.getString('Sold out'),
          'availabilityCalendar': scope.calendar.availabilityCalendar,
          'isDateInRange': utils.isDateInRange,
          'dateFrom': scope.calendar.dateFrom,
          'dateTo': scope.calendar.dateTo,
          'currency': scope.calendar.currency,
        }))(scope));

        updateWindowPosition();
      });

      $(window).on('resize', updateWindowPosition);

      if (today === scope.calendar.dateFrom) {
        leftArrow.addClass('disabled');
      }

      leftArrow.on('click', function () {
        if (today !== scope.calendar.dateFrom) {
          scope.calendar.updateDate();
          scope.calendar.updateCalendar();
        } else {
          leftArrow.addClass('disabled');
        }
      });

      rightArrow.on('click', function () {
        scope.calendar.updateDate({type: 'add'});
        scope.calendar.updateCalendar();
        if (today !== scope.calendar.dateFrom) {
          leftArrow.removeClass('disabled');
        }
      });

      function updateWindowPosition() {
        // var numberOfDays = moment(scope.calendar.dateTo).diff(scope.calendar.dateFrom,'days') + 1,
        var firstRow = $('.dr-availability-calendar-row.main-graph').first(),
          firstActiveCell = firstRow.find('.active').first();

        selectedRange.css({
          border: scope.calendar.duration > scope.calendar.maximumDays ? gettextCatalog.getString('none') : '',
          width: scope.calendar.duration * CELL_WIDTH + 7,
          height: ROW_HEIGHT * scope.calendar.roomNumbers + 5,
          top: firstRow ? firstRow.position().top - 5 : '',
          left: firstActiveCell ? firstActiveCell.position().left - 5 : '',
        });

        selectedRangeText.text(moment(scope.calendar.dateFrom).locale(selectedLanguage).format('DD MMM') + ' - ' + moment(scope.calendar.dateTo).locale(selectedLanguage).format('DD MMM'));
      }
    },
    controllerAs: 'calendar',
    controller: function ($scope, $rootScope, utils, DiveOperator) {
      var vm = this;

      vm.updateCalendar = updateCalendar;
      $scope.$watch(function () {
        return vm.searchTriggered;
      }, updateCalendar);

      // $scope.$watch(function(){
      //     return vm.dateFrom +  vm.duration + vm.roomSelected + vm.roomsAndGuests;
      // }, updateCalendar);

      function updateCalendar() {
        if (vm.roomSelected === 'more') {
          return 1;
        }
        vm.loading = true;

        var ROW_WIDTH_PERCENT = 0.65;

        if (window.innerWidth < 1400 && window.innerWidth > 767) {
          ROW_WIDTH_PERCENT = 0.6;
        } else if (window.innerWidth < 768) {
          return 1;
        }

        vm.maximumDays = Math.floor(($('.dr-availability-calendar').width() * ROW_WIDTH_PERCENT) / CELL_WIDTH) - 1;

        if (vm.maximumDays % 2 !== 0) {
          vm.maximumDays -= 1;
        }

        var startDate = Math.round((vm.maximumDays - vm.duration) / 2),
          endDate = vm.maximumDays - startDate - vm.duration;

        vm.dateTo = moment(vm.dateFrom).add(vm.duration, 'days').format('YYYY-MM-DD');

        var firstDate = moment(vm.dateFrom).subtract(startDate, 'days').format('YYYY-MM-DD'),
          lastDate = moment(vm.dateTo).add(endDate, 'days').format('YYYY-MM-DD'),
          guests,
          roomParams = _.find(vm.roomsAndGuests, {id: vm.roomSelected}),
          divers = roomParams ? roomParams.divers : 0;

        if (roomParams.details) {
          guests = [];
          _.each(roomParams.details, function (val) {
            guests.push(val.nonDivers + val.divers);
          });
        } else {
          guests = roomParams.divers + roomParams.nonDivers;
        }

        DiveOperator.getResortAvailability({
          date_0: firstDate,
          date_1: lastDate,
          nights: vm.duration,
          date_start: vm.dateFrom,
          guests: guests,
          divers: divers,
          guests_split: roomParams.details || undefined,
        }).then(function (data) {
          vm.availabilityCalendar = data;
          vm.roomNumbers = data.length;

          vm.availabilityCalendar = _(vm.availabilityCalendar).each(function (val) {
            // var index = 0;
            val.totalPrice = $rootScope.setValue(val.priceForDives, val.divesCurrency, true, vm.currency);
            _.each(val.details, function (v) {
              if (utils.isDateInRange(v.date, vm.dateFrom, vm.dateTo)) {
                v.selected = true;
                val.totalPrice += +v.minPrice;

                if (!v.isAvailable) {
                  val.notAvailable = true;
                }

                // index = k;
              }
            });
          }).value();

          vm.monthes = [];

          var monthes = _.groupBy(vm.availabilityCalendar[0].details, function (result) {
            return moment(result.date).startOf('month');
          });

          _.each(monthes, _.memoize(function (val, key) {
            _.each(val, function (v, k) {
              vm.monthes.push(k === 0 ? moment(key).locale(selectedLanguage).format('MMM YYYY') : '');
            });
          }));

          vm.loading = false;
        });
      }
    },
  };
});
